import {
  pbr_select_sort,
  pbr_toggle_filter,
  pbr_toggle_filter_flyers,
} from '../tracking/filters.tracking';

export function trackSelectSort(
  sortName: string,
  filterSelectionType: string,
): Object {
  return {
    type: pbr_select_sort,
    payload: { sortName, filterSelectionType },
  };
}

export function trackToggleFilter(
  type: string,
  value: string,
  toTurnOn: boolean,
  filterSelectionType: string,
): Object {
  return {
    type:
      filterSelectionType === 'flyerFilters'
        ? pbr_toggle_filter_flyers
        : pbr_toggle_filter,
    payload: { type, value, toTurnOn, filterSelectionType },
  };
}
